// NOTE(DS migration, GOTU-3282): layout/text/color primitives migrated to @tempmee/react + @tempmee/tailwind.
// Non-primitive commonComponents here (DotsMenu/IconButton/Button/BackButton/CustomPortal/Checkbox/GridTable/EmptyScreen/Tooltip) have no DS equivalent yet and are kept
// intentionally — they belong to the separate form/action/shared-component migration categories.
import { useState } from 'react';
import { Screen, Spinner } from '@tempmee/react';
import { BackButton, GridTable } from '~/commonComponents';
import { EmptyScreen } from '../../../../commonComponents/EmptyScreen/EmptyScreen';
import { EmptyInvitesIcon } from '../../../../images/emptyScreenIcons';
import { ExpandableInviteCard } from './ExpandableInviteCard';
import { useOfficeJobInvites } from './useOfficeJobInvites';

export const OfficeJobInvites = () => {
  const { jobs, handleScrollList, isLoading, isLoadingFirstPage } = useOfficeJobInvites();
  const [openCardIndex, setOpenCardIndex] = useState(null);

  const handleCardToggle = (index) => {
    setOpenCardIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="Invites" />
      <Screen.Body inset style={{ height: 600, overflowY: 'auto' }} onScroll={handleScrollList}>
        {isLoadingFirstPage ? (
          <div style={{ marginTop: 20 }}>
            <Spinner centered variant="default" size="md" />
          </div>
        ) : (
          <>
            {!jobs?.length && (
              <EmptyScreen
                Icon={EmptyInvitesIcon}
                title="No invitations have been sent!"
                description={
                  <>
                    Invite a favorite and/or those
                    <br />
                    professionals who have recently worked at your
                    <br />
                    office to come back for another shift!
                  </>
                }
              />
            )}

            <div
              style={{
                maxWidth: 860,
                margin: 'auto',
              }}
            >
              {jobs?.length > 0 && (
                <GridTable
                  data={jobs}
                  renderRow={(item) => (
                    <ExpandableInviteCard
                      job={item}
                      isOpen={openCardIndex === item?.id}
                      onToggle={() => handleCardToggle(item?.id)}
                    />
                  )}
                  headerTitles={['Shifts Date', 'Profession', 'Shifts Time']}
                  headerStyle={{
                    marginLeft: 80,
                  }}
                  isLoading={isLoading}
                />
              )}
            </div>
          </>
        )}
      </Screen.Body>
    </Screen>
  );
};
